import { render } from "./bread_crumbs.vue?vue&type=template&id=7b6061be&scoped=true"
import script from "./bread_crumbs.vue?vue&type=script&lang=js"
export * from "./bread_crumbs.vue?vue&type=script&lang=js"

import "./bread_crumbs.vue?vue&type=style&index=0&id=7b6061be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6061be"]])

export default __exports__